routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.detailedPayment', {
      url: "zona-de-pagos/pago-detallado",
      template: `<detailed-payment sh-ctrl="shCtrl"></detailed-payment>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/pay-zone/detailed-payment/detailed-payment.config.js